<template>
    <div id="table-search-field">
        <v-text-field
            v-model="model_search"
            append-icon="search"
            :label="label"
            single-line
            hide-details
        />
    </div>
</template>

<script>
    export default {
        name: 'search_field',

        props: {
            search: {
                type: String,
                default() {
                    return ''
                }
            }
        },

        computed: {
            model_search: {
                get() {
                    return this.search
                },

                set(value) {
                    this.$emit('update:search', value)
                }
            },

            label() {
                return this.$t('__search_field.label')
            }
        }
    }
</script>

<style lang="scss" scoped>
    #table-search-field {
        margin-right: 1rem;
    }
</style>